var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useSelf } from "@rentiohq/shared-frontend/dist/redux/auth/auth.hooks";
import { updateContact } from "@rentiohq/shared-frontend/dist/redux/contact/contact.actions";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import React from "react";
import { useDispatch } from "react-redux";
import { ESpacings, Icon, TextStyle } from "../";
import { AccountInfoListItem } from "../AccountInfoListItem/AccountInfoListItem";
import { AddContactModal } from "../AddContactModal";
import { ContactEditModal } from "../ContactEditModal";
import { ContactFetchListItem } from "../ContactFetchListItem";
import { ContactInfoListItem } from "../ContactInfoListItem";
import { ResourceList } from "../ResourceList";
import { SelectEmployeeDropdown } from "../SelectEmployeeDropdown";
export var MemberList = function (props) {
    var role = props.role, members = props.members, _a = props.actions, actions = _a === void 0 ? [] : _a, _b = props.getActions, getActions = _b === void 0 ? function () { return []; } : _b, getContactInfoForAccount = props.getContactInfoForAccount, onSwitchEmployee = props.onSwitchEmployee, onRemoveEmployee = props.onRemoveEmployee, getSubtitle = props.getSubtitle, getExtraSubtitle = props.getExtraSubtitle, _c = props.mediaSize, mediaSize = _c === void 0 ? "medium" : _c, _d = props.boxProps, boxProps = _d === void 0 ? { p: ESpacings.tight } : _d;
    var accounts = members.map(function (member) { return member.account; });
    var resourceListItemProps = {
        boxProps: __assign({}, boxProps),
        mediaSize: mediaSize,
    };
    var dispatch = useDispatch();
    var broker = useSelf().broker;
    var _e = React.useState(), contactToEdit = _e[0], setContactToEdit = _e[1];
    var _f = React.useState(), accountToAdd = _f[0], setAccountToAdd = _f[1];
    var _g = React.useState(), accountIdToSwitchEmployee = _g[0], setAccountIdToSwitchEmployee = _g[1];
    // Event handlers
    var handleEditModalClose = function () {
        setContactToEdit(undefined);
    };
    var handleAddAccountClose = function () {
        setAccountToAdd(undefined);
    };
    var handleEditSubmit = function (contact) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setContactToEdit(undefined);
            dispatch(updateContact.actions.start({ contactId: contact.id, contact: contact }));
            return [2 /*return*/];
        });
    }); };
    var handleAddSubmit = function (contact) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setAccountToAdd(undefined);
            return [2 /*return*/];
        });
    }); };
    // Render
    var renderListItem = function (account) {
        var _a, _b, _c;
        // Only take first one
        var employeeAccount = (_c = (_b = (_a = members.find(function (member) { return member.account.id === account.id; })) === null || _a === void 0 ? void 0 : _a.employeeRoles) === null || _b === void 0 ? void 0 : _b[role]) === null || _c === void 0 ? void 0 : _c[0];
        return (_jsx(ContactFetchListItem, { account: account, accountId: account.id, renderAccount: renderAccount(employeeAccount), renderContact: renderContact(employeeAccount) }));
    };
    var renderAccount = function (employeeAccount) { return function (account) { return (_jsx(AccountInfoListItem, { account: account, employeeAccount: employeeAccount, actions: actions, getActions: function (accountId) {
            return getActions({ role: role, accountIds: [accountId], employeeAccount: employeeAccount });
        }, getContactInfoForAccount: getContactInfoForAccount, resourceListItemProps: resourceListItemProps, onAddAccount: function (account, accountContactInfo) {
            setAccountToAdd({
                account: account,
                accountContactInfo: accountContactInfo,
            });
        }, getSubtitle: getSubtitle, getExtraSubtitle: getExtraSubtitle })); }; };
    var renderContact = function (employeeAccount) { return function (contact) {
        var employeeActions = [];
        var isSelfBroker = broker &&
            __spreadArray([
                contact.account,
                contact.personalAccountId
            ], contact.accountIds, true).includes(broker.accountId);
        // Only allow a broker to edit their own employees
        if (isSelfBroker && onSwitchEmployee) {
            employeeActions.push({
                content: employeeAccount
                    ? getLocalizedText("property.case_manager.cta.select_other")
                    : getLocalizedText("property.case_manager.cta.select"),
                media: _jsx(Icon, { source: "profile" }),
                onClick: function () {
                    setAccountIdToSwitchEmployee(contact.account.id);
                },
            });
        }
        // Only allow a broker to remove their own employees
        if (isSelfBroker && onRemoveEmployee && employeeAccount) {
            employeeActions.push({
                content: (_jsx(TextStyle, { variation: "negative", children: getLocalizedText("property.case_manager.cta.remove") })),
                media: _jsx(Icon, { source: "bin", color: "red" }),
                onClick: function () {
                    onRemoveEmployee === null || onRemoveEmployee === void 0 ? void 0 : onRemoveEmployee(role, employeeAccount.id);
                },
            });
        }
        return (_jsxs(_Fragment, { children: [_jsx(ContactInfoListItem, { accounts: accounts, employeeAccount: employeeAccount, contact: contact, actions: __spreadArray(__spreadArray([], employeeActions, true), actions, true), getActions: function (contact) {
                        return getActions({
                            role: role,
                            accountIds: __spreadArray([
                                contact.accountId,
                                contact.personalAccountId
                            ], contact.accountIds, true),
                            employeeAccount: employeeAccount,
                        });
                    }, resourceListItemProps: resourceListItemProps, setContactToEdit: setContactToEdit, getSubtitle: getSubtitle
                        ? function () {
                            return getSubtitle === null || getSubtitle === void 0 ? void 0 : getSubtitle(__spreadArray([
                                contact.accountId,
                                contact.personalAccountId
                            ], contact.accountIds, true), contact);
                        }
                        : undefined, getExtraSubtitle: getExtraSubtitle
                        ? function () {
                            return getExtraSubtitle === null || getExtraSubtitle === void 0 ? void 0 : getExtraSubtitle(__spreadArray([
                                contact.accountId,
                                contact.personalAccountId
                            ], contact.accountIds, true), contact);
                        }
                        : undefined }), accountIdToSwitchEmployee === contact.account.id &&
                    onSwitchEmployee && (_jsx(SelectEmployeeDropdown, { selectedEmployeeId: employeeAccount === null || employeeAccount === void 0 ? void 0 : employeeAccount.id, onSelectEmployee: function (newEmployeeAccountId) {
                        onSwitchEmployee(role, newEmployeeAccountId, employeeAccount === null || employeeAccount === void 0 ? void 0 : employeeAccount.id);
                        setAccountIdToSwitchEmployee(undefined);
                    }, onCancel: function () {
                        setAccountIdToSwitchEmployee(undefined);
                    }, boxProps: {
                        mb: ESpacings.base,
                    } }))] }));
    }; };
    return (_jsxs(_Fragment, { children: [_jsx(ResourceList, { items: accounts, renderItem: renderListItem }), !!contactToEdit && (_jsx(ContactEditModal, { contactId: contactToEdit.id, onClose: handleEditModalClose, onSubmit: handleEditSubmit })), !!accountToAdd && (_jsx(AddContactModal, { type: !!accountToAdd.account.company ? "company" : "contact", contact: __assign(__assign(__assign({}, accountToAdd.account), accountToAdd.accountContactInfo), { firstname: accountToAdd.account.firstname, lastname: accountToAdd.account.lastname, company: accountToAdd.account.company }), baseAccountId: accountToAdd.account.id, onClose: handleAddAccountClose, onSubmit: handleAddSubmit }))] }));
};
